const SET_WAREHOUSE = 'SET_WAREHOUSE';
const ADD_WAREHOUSE = 'ADD_WAREHOUSE';
const DELETE_WAREHOUSE = 'DELETE_WAREHOUSE';
const SET_STOCK = 'SET_STOCK';
const EDIT_WAREHOUSE = 'EDIT_WAREHOUSE';
const SET_PRODUCT_TYPE = 'SET_PRODUCT_TYPE';
const SET_VARIANTS = 'SET_VARIANTS';
const SET_OPTIONS = 'SET_OPTIONS';
const SET_VARIANT_STOCK = 'SET_VARIANT_STOCK';
const UPDATE_STOCK_VARIABLE = 'UPDATE_STOCK_VARIABLE';
const UPDATE_LIST_WAREHOUSE = 'UPDATE_LIST_WAREHOUSE';
const UPDATE_STOCK_SIMPLE = 'UPDATE_STOCK_SIMPLE';
const SET_PRODUCT_PRICES = 'SET_PRODUCT_PRICES';
const SET_IS_ATTRIBUTE_ADDED = 'SET_IS_ATTRIBUTE_ADDED';

const state = {
	warehouse: [],
	stock: {
		enabled: false,
		multi_warehouse: false,
		backorder: 0,
		status: 0,
		quantity: 0,
		multi_warehouse_type: 'nearest',
	},
	productType: 'simple',
	variants: {},
	options: [],
	variantStock: [],
	productPrices: [],
	isAttributeAdded: false,
};

const getters = {
	warehouse: state => state.warehouse,
	stock: state => state.stock,
	type: state => state.productType,
	variants: state => state.variants,
	options: state => state.options,
	variantStock: state => state.variantStock,
	productPrices: state => state.productPrices,
	isAttributeAdded: state => state.isAttributeAdded,
	simpleStockTotal: (state) => {
		const warehouses = state?.warehouse;
		let stock = 0;

		for (let i = 0; i < warehouses.length; i++) {
			const stockQty = warehouses[i]?.quantity ?? 0;
			stock += stockQty;
		}

		return stock;
	},
};

const mutations = {
	[SET_WAREHOUSE](state, payload) {
		state.warehouse = payload.map(curr => ({
			...curr,
			quantity: curr.quantity ?? 0,
		}));
	},
	[ADD_WAREHOUSE](state, payload) {
		const params = {
			...payload,
			quantity: 0,
		};
		const warehouse = state.warehouse;
		warehouse.unshift(params);
		state.warehouse = warehouse;
	},
	[DELETE_WAREHOUSE](state, payload) {
		const index = state.warehouse.findIndex(curr => curr._id === payload);
		if (index !== -1) {
			state.warehouse.splice(index, 1);
		}
	},
	[SET_STOCK](state, payload) {
		state.stock = payload;
	},
	[SET_PRODUCT_PRICES](state, payload) {
		state.productPrices = payload;
	},
	[EDIT_WAREHOUSE](state, payload) {
		const index = state.warehouse.findIndex(curr => curr.warehouse_id === payload._id);
		if (index !== -1) {
			state.warehouse[index].warehouse_label = payload.label;
		}
	},
	[SET_PRODUCT_TYPE](state, payload) {
		state.productType = payload;
	},
	[SET_VARIANTS](state, payload) {
		state.variants = payload;
	},
	[SET_OPTIONS](state, payload) {
		const options = payload.options.map(curr => ({
			...curr,
			warehouse_id: curr._id,
		}));
		state.options = options;
	},
	[SET_VARIANT_STOCK](state, payload) {
		const stockVariant = payload.stockVariant;
		const variants = payload.variations;
		for (let index = 0; index < variants.length; index++) {
			const variant = variants[index];
			const indexMatch = stockVariant.findIndex(curr => curr.name === variant.name);
			if (indexMatch !== -1) {
				stockVariant[indexMatch].quantity = variant.quantity;
			}
		}
		state.variantStock = stockVariant;
	},
	[UPDATE_STOCK_VARIABLE](state, payload) {
		const index = state.variantStock.findIndex(curr => curr.name === payload.name);
		state.variantStock[index].quantity = payload.value;
	},
	[UPDATE_LIST_WAREHOUSE](state, payload) {
		const index = state.warehouse.findIndex(curr => curr._id === payload._id);
		if (index !== -1) {
			state.warehouse[index] = payload;
		}
	},
	[UPDATE_STOCK_SIMPLE](state, payload) {
		const index = state.warehouse.findIndex(curr => curr._id === payload.warehouse_id);
		if (index !== -1) {
			state.warehouse[index].quantity = payload.value;
		}
	},
	[SET_IS_ATTRIBUTE_ADDED](state, payload) {
		state.isAttributeAdded = payload;
	},
};
const actions = {
	setWarehouse({ commit }, payload) {
		commit(SET_WAREHOUSE, payload);
	},
	addWarehouse({ commit }, payload) {
		commit(ADD_WAREHOUSE, payload);
	},
	deleteWarehouse({ commit }, payload) {
		commit(DELETE_WAREHOUSE, payload);
	},
	setStock({ commit }, payload) {
		commit(SET_STOCK, payload);
	},
	editWarehouse({ commit }, payload) {
		commit(EDIT_WAREHOUSE, payload);
	},
	setProductType({ commit }, payload) {
		commit(SET_PRODUCT_TYPE, payload);
	},
	setVariants({ commit }, payload) {
		commit(SET_VARIANTS, payload);
	},
	setOptions({ commit, getters }, options) {
		const warehouse = getters.warehouse;
		const params = {
			options,
			warehouse,
		};
		commit(SET_OPTIONS, params);
	},
	appendOptions({ commit, getters }, warehouse) {
		const currentOptions = [
			...getters.options,
			warehouse,
		];
		const params = {
			options: currentOptions,
		};
		commit(SET_OPTIONS, params);
	},
	setVariantStock({ commit }, payload) {
		commit(SET_VARIANT_STOCK, payload);
	},
	updateStockVariable({ commit }, payload) {
		commit(UPDATE_STOCK_VARIABLE, payload);
	},
	updateStockSimple({ commit }, payload) {
		commit(UPDATE_STOCK_SIMPLE, payload);
	},
	updateListWarehouse({ commit }, payload) {
		commit(UPDATE_LIST_WAREHOUSE, payload);
	},
	setProductPrices({ commit }, payload) {
		commit(SET_PRODUCT_PRICES, payload);
	},
	setAttributeAdded({ commit }, payload) {
		commit(SET_IS_ATTRIBUTE_ADDED, payload);
	},
};
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
